module.exports = __webpack_public_path__ + "static/media/LOGO@2x.5af8fb7f.png";